import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { APP_FULL_NAME } from '../constants/common';
import { ROUTES } from '../constants/routes';
import type { RootState } from '../redux/store';

const PublicRoute = ({ component: Component, title, ...props }: any) => {
    const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
    const appearance = useSelector((state: RootState) => state.basic.appearance);
    const { isIgnoreAuthentication } = props;

    useEffect(() => {
        document.title = `${title} - ${appearance.web_title ?? APP_FULL_NAME}`;
        const favicon = document.getElementById('favicon') as HTMLLinkElement;

        // Only override the default favicon when the org has actually set one — otherwise keep the existing icon
        if (favicon && appearance?.favicon) {
            favicon.href = appearance.faviconUrl + appearance.favicon;
        }
    }, [title, appearance]);

    return isAuthenticated && !isIgnoreAuthentication ? <Navigate to={ROUTES.HOME} /> : <Component {...props} />;
};

export default PublicRoute;
